import { useTranslation } from "react-i18next";
import { testimonials } from "@/mocks/siteData";
import SectionHeading from "@/components/feature/SectionHeading";

export default function TestimonialsSection() {
  const { t } = useTranslation();

  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <SectionHeading
          eyebrow={t("testimonials.eyebrow")}
          title={
            <>
              {t("testimonials.title1")}
              <br />
              {t("testimonials.title2")}
            </>
          }
        />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {testimonials.map((item) => {
            return (
              <div
                key={item.id}
                className="bg-background-50 rounded-lg p-7 md:p-8 border border-background-200 hover:border-primary-300 transition flex flex-col"
              >
                <div className="flex text-primary-500">
                  {[0, 1, 2, 3, 4].map((star) => (
                    <i key={star} className="ri-star-fill w-5 h-5 flex items-center justify-center" />
                  ))}
                </div>
                <p className="mt-5 text-foreground-700 text-base leading-relaxed flex-1">
                  &ldquo;{t(`testimonials.${item.id}.quote`)}&rdquo;
                </p>
                <div className="mt-6 flex items-center gap-4 pt-6 border-t border-background-200">
                  <div className="w-12 h-12 rounded-full overflow-hidden bg-background-200 shrink-0">
                    <img alt={item.name} className="w-full h-full object-cover object-top" src={item.avatar} />
                  </div>
                  <div>
                    <div className="font-heading font-bold text-foreground-900 text-sm">{item.name}</div>
                    <div className="text-foreground-500 text-xs">{t(`testimonials.${item.id}.role`)}</div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}